/*
  Logic for easy cancel
  Show:
  - If tour TnC is easy & has text
  - If operator TnC is easy, has text and tour TnC is empty
  Do not show:
  - If tour TnC is worse
  - If operator TnC is worse
  - If tour TnC and/or operator TnC is empty
  Util function - takes in operator TnC, tour TnC
  - Checks if tour tnc is easy -- short circuit
  - tour tnc worse -- short circuit
  - then check if operator TnC is easy - true
  - if operator TnC worse - false
  - if all empty, nothing
   */

export const checkTourTnC = (operatorTnC, tourTnC) => {
  if (!operatorTnC && !tourTnC) {
    return
  }
  if (tourTnC) {
    if (tourTnC.lifetime) {
      if (tourTnC.worse) {
        return { lifetime: true, worse: true, text: tourTnC.text }
      }
      return { lifetime: true, text: tourTnC.text }
    }
    if (tourTnC.text && tourTnC.worse) {
      return { worse: true, text: tourTnC.text }
    }
  }
  if (operatorTnC) {
    if (operatorTnC.lifetime) {
      if (operatorTnC.worse) {
        return { lifetime: true, worse: true, text: operatorTnC.text }
      }
      return { lifetime: true, text: operatorTnC.text }
    }
    if (operatorTnC.text && operatorTnC.worse) {
      return { worse: true, text: operatorTnC.text }
    }
  }
}
